export default "20251218.1 \r\n"